// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import NavBar from "../../components/NavBar";
import {Delete} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {Backdrop, CircularProgress} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";
import {ThemeContext} from "../../App";


export default function Comments() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()
  const theme = React.useContext(ThemeContext)

  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const [listComment, setListComment] = React.useState([])


  React.useEffect(() => {
    getListMessage()
  }, [])

  const getListMessage = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', '/getUserMessages', '',
       "application/x-www-form-urlencoded", {
         "pageIndex": "1",
         "PageSize": "10",
         "ToSearch": ""
       }, '',''
    )
    dispatch(setLoading(false))
    setListComment(fetch?.Data?.messageitems)
  }

  return (
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       {/*کامپوننت نوبار*/}
       <div className="d-block d-lg-none">
         <NavBar blue back/>
       </div>

       <div className="container">
         <div className="commentsPage desktopSection">
           <div className="commentFilter">
             <h4 className="titleSection">{t("dashboard.message.t1")}</h4>
           </div>

           <div className="commentsList">
             <div className="row">
               {
                 listComment?.map(item => {
                   return (
                      <>
                        <div className="col-12 col-md-6">
                          <div className="comments">
                            <div className="commentInfo">
                              <div>
                                {/*<img src={require('./../../assets/img/company.png')} alt=""/>*/}
                                <div>
                                  <p>{item?.Subject}</p>
                                  <span>{item?.ShamsiCreatedDate}</span>
                                </div>
                              </div>
                              <button type="button">
                                <Delete/>
                              </button>
                            </div>
                            <div className="commentText">
                              <span>{item?.MessageText}</span>
                            </div>
                          </div>
                        </div>
                      </>
                   )
                 })
               }
               <div className="col-12 col-md-6">
                 {/*// <div className="comments">*/}
                 {/*//   <div className="commentInfo">*/}
                 {/*//     <div>*/}
                 {/*//       <img src={require('./../../assets/img/company.png')} alt=""/>*/}
                 {/*//       <div>*/}
                 {/*        <p>ثبت سفارش تکی</p>*/}
                 {/*        <span>پشتیبانی پستِکس - امروز. 15:30</span>*/}
                 {/*      </div>*/}
                 {/*    </div>*/}
                 {/*    <button type="button">*/}
                 {/*      <Delete/>*/}
                 {/*    </button>*/}
                 {/*  </div>*/}
                 {/*  <div className="commentText">*/}
                 {/*    <span>سفارش شما ثبت شد</span>*/}
                 {/*  </div>*/}
                 {/*</div>*/}
               </div>


               {
                 !listComment?.length && <div className="notFindMessage">
                   <img src={require('./../../assets/img/vector/1.png')} alt="vector"/>
                   <p>{t("error.t2")}</p>
                 </div>
               }
             </div>
           </div>
         </div>
       </div>
     </>
  )
}
